import { Controller, useFormContext } from "react-hook-form";
import {
  convertCronToSchedulerData,
  convertToCron,
  DEFAULT_SCHEDULER_DATA,
  Scheduler,
  REQUIRED_ERROR_MESSAGE,
} from "@SeemplicityDev/shared";
import type { ComponentProps } from "react";

// Scheduler's onChange value is untyped upstream (SchedulerProps.onChange);
// reuse its declared parameter type so the callback param is not implicitly any.
type SchedulerChangeValue = Parameters<
  NonNullable<ComponentProps<typeof Scheduler>["onChange"]>
>[0];

// SchedulerData isn't exported from the shared barrel; derive it from the
// Scheduler `data` prop so convertToCron's argument type stays aligned.
type SchedulerData = NonNullable<ComponentProps<typeof Scheduler>["data"]>;

interface SchedulerInputProps {
  isSummary?: boolean;
}

const SchedulerInput: React.FC<SchedulerInputProps> = ({
  isSummary = false,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={`schedule`}
      defaultValue={convertToCron({
        schedulerData: DEFAULT_SCHEDULER_DATA,
      })}
      render={({ field: { value, onChange } }) => {
        return (
          <Scheduler
            hideEnds
            disableInterval
            data-testid="automation-settings-scheduling"
            hideInterval
            label={isSummary ? "Scheduling" : ""}
            onChange={(data: SchedulerChangeValue) =>
              onChange(convertToCron({ schedulerData: data as SchedulerData }))
            }
            data={
              convertCronToSchedulerData({
                cron: value || "",
                withOffset: true,
              }) as SchedulerData
            }
            viewMode={isSummary}
          />
        );
      }}
      control={control}
      rules={{ required: REQUIRED_ERROR_MESSAGE }}
    />
  );
};

export default SchedulerInput;
